import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import { UtilsService } from '../../shared/utils-service';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-mass-submission-history',
	templateUrl: './mass-submission-history.component.html',
	styleUrls: ['./mass-submission-history.component.css']
})
export class MassSubmissionHistoryComponent implements OnInit {
	private loader: boolean= false;
	private showAdvanced: boolean;
	private srchData : any = {};
	dataJson : any = [];
	batchList : any = [];
	srchURL : string = this.utils.url+'/bulkBlackListSubmission/batchBulkListSubmissionSearch';
	viewDetailsURL : string = this.utils.url+'/bulkBlackListSubmission/batchBulkListViewDetails';
	downloadFileURL : string = this.utils.url+'/bulkBlackListSubmission/downloadBatchFile?fileName=';
	dataSource: any = [];
	search: any = {};
	displayedColumns: any = [];
	viewDetailsContent: any = {};
	viewErrorDetailsContent: any = {};
	Durl:any="";
	arStatusMap: any = ['', 'Submitted', 'Success', 'Failed', 'In Progress'];
	private loggedInUser: any = {};
	constructor(private http: Http, private utils: UtilsService, private router: Router, private matSnackBar: MatSnackBar) {
		this.loggedInUser = this.utils._checkSession({'page': 'telco-audit-trail'});
		this.showAdvanced = true;
		this.displayedColumns = ['batchId', 'batchStatus', 'recordTotal', 'recordSuccess', 'recordFail', 'submitDate', 'submitTime', 'userId','actions'];
	}

	ngOnInit() {
	}

	@ViewChild(MatPaginator) paginator : MatPaginator;
	@ViewChild(MatSort) sort : MatSort;

	searchData($event, srchData) {
		this.paginator.pageIndex = 0;
		this.srchData=srchData;
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);

		//console.log(this.srchData);
		let dataStr = JSON.stringify({
			"batchId" : this.srchData.batchId,
			"status" : this.srchData.status,
			"dateRangeFrom" : this.utils.dateToDB(this.srchData.dateRangeFrom),
			"dateRangeTo" : this.utils.dateToDB(this.srchData.dateRangeTo),
			"userId" : this.loggedInUser.userId
		});
		if(this.srchData.batchId!=undefined || this.srchData.dateRangeFrom!=undefined || this.srchData.dateRangeTo!=undefined)	{						
     if(this.srchData.batchId!="" || this.srchData.dateRangeFrom!="" || this.srchData.dateRangeTo!=""){
		this.loader=true;
		this.http.post(this.srchURL, dataStr, {headers: headers}).subscribe(data => {
		this.loader=false;
			let result = JSON.parse(data['_body']);
			// this.dataJson = result['batchList'];
			
			
			if(result['batchList'] == null){
				var message=result['ddmfResponseStatus'].responseStatusMessage;
					// this.matSnackBar.open(message, 'Close', {
	    //   			duration: 5000,
	    // 		});
	   			this.utils.notify(message);
    			this.dataJson = [];
    			this.paginator.length = 0;
    			this.dataJson.paginator = this.paginator;
				this.dataJson.sort = this.sort;
    			this.batchList = [];
				//console.log(this.dataJson);
    		} else {
    			this.batchList = result['batchList'];
				this.dataJson = new MatTableDataSource(result['batchList']);
				this.dataJson.paginator = this.paginator;
				this.dataJson.sort = this.sort;
				//console.log(this.dataJson);
			}
		},
		error => {
		this.loader=false;
				// this.matSnackBar.open('Something went wrong!! Please try after some time.', 'Close', {
    //   			duration: 5000,
    // 		});
	   		this.utils.notify('Something went wrong!! Please try after some time.');
		})
		}
  	else{
  		this.utils.notify('Please enter the fields.');
  	}
  	}
  	else{
  		this.utils.notify('Please enter the fields.');
  	}
	}
	
	resetData(){
   this.srchData = {};
   this.dataJson = [];
   this.paginator.length = 0;
   this.dataJson.paginator = this.paginator;
   this.dataJson.sort = this.sort;
   this.batchList = [];
  }

	viewDetails(el) {
		this.viewDetailsContent = el;
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
	this.loader=true;
		this.http.post(this.viewDetailsURL, {"batchId": el.batchId}, {headers: headers}).subscribe(data => {
		this.loader=false;
			if (data['_body']) {
				let json = JSON.parse(data['_body']);
				this.viewErrorDetailsContent = json['errorLog'];
				this.Durl = this.downloadFileURL+this.viewDetailsContent.batchId;
			}
		},
		error => {
		this.loader=false;
	   		this.utils.notify('Something went wrong!! Please try after some time.');
		});
		// this.view_details_flag = true;
	}
	goToURL(url){
		this.router.navigateByUrl(url);
		}
		
		dateValidateLeapYear(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.srchData[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.srchData[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.srchData[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.srchData[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.srchData[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.srchData[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.srchData[field] = "";
						}
					}
				}
			}
		}
	}
		
		dateValidate(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		////console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				//console.log(val);
				this.srchData[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				//console.log(val);
				this.srchData[field] = val;
			}
			//console.log(val, 'value', this.srchData[field], field);
		} else {
			e.preventDefault();
		}
	}
	
	downloadFile(batchId){
	var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
	this.http.get(this.Durl, {headers: headers}).subscribe(data => {
			var mediaType = 'application/csv';
	        var blob = new Blob([data['_body']], {type: mediaType});
	        var filename = batchId+'.csv';
	         FileSaver.saveAs(blob, filename);	
		});
	}
	

}



// WEBPACK FOOTER //
// ./src/app/telco-audit-trail/mass-submission-history/mass-submission-history.component.ts